<template>
    <div class="huiyuan_box" v-loading="loading">
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                姓名
            </div>
            <div class="input2">
                <el-input v-model="forms.name" placeholder="请输入内容"></el-input>
            </div>
        </div>
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                手机号
            </div>
            <div class="input2">
                <el-input v-model="forms.mobile" placeholder="请输入内容" disabled></el-input>
            </div>
        </div>
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                电子邮箱
            </div>
            <div class="input2">
                <el-input v-model="forms.email" placeholder="请输入内容"></el-input>
            </div>
        </div>
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                所在地区
            </div>
            <div class="input2">
                <el-cascader placeholder="请选择城市名称" clearable v-model="area_ac" :options="area_list"  :props="props" @change="handleChange"></el-cascader>
            </div>
        </div>
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                企业名称
            </div>
            <div class="input2">
                <el-input v-model="forms.company" placeholder="请输入内容"></el-input>
            </div>
        </div>
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                营业执照号
            </div>
            <div class="input2">
                <el-input v-model="forms.credit" placeholder="请输入内容"></el-input>
            </div>
        </div>
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                营业执照
               
            </div>
            <div class="input_img">
                <div class="img_text">请上传营业执照扫描件，格式为jpg、png</div>
                <div class="img_list">
                    <div class="img_item" v-for="(item,index) in credit_img">
                        <!-- <img src="../../assets/img/login/img_up.png" alt="" class="imgs"> -->
                        <img :src="item" alt="" class="imgs">

                        <img src="../../assets/img/login/clear.png" alt="" class="img_clear" @click="handle_clear(index,'credit_img')">


                    </div>
                    <img src="../../assets/img/login/img_up.png" alt="" class="img_add" @click="handle_img_add('credit_img')">
                </div>
            </div>
        </div> 


        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                期望从网站中获得什么
            </div>
            <div class="input3">
                <el-input type="textarea"  placeholder="请输入内容" v-model="forms.desire"></el-input>
            </div>
        </div>
        <div class="form_flex">
            <div class="form_title">
            </div>
            <div class="btn_flex">
                <div class="btns1" @click="handle_end">提交</div>
                <div class="btns2" @click="$router.back()">取消</div>
            </div>
        </div>
        <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import upload from '@/components/upload/upload.vue'

export default {
    components: {
        upload,
    },
    name: "homes",
    data() {
        return {
            types:JSON.stringify(['jpg','png']),
            loading:false,
            forms:{
                type:6,
                name:'',//姓名
                mobile:'',//手机号
                email:'',//电子邮箱
                province:'',//省
                city:'',//市
                area:'',//区
                company:'',//企业名称
                credit:'',//营业执照号
                credit_img:'',//营业执照图片
                desire:'',//期望获得什么
            },
            area_list: [],
            area_ac:[],
            props:{
                label:'name',
                value:'id',
                children:'children',
            },
            credit_img:[]
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {
        this.get_area()
        this.get_user()

    },
    methods: {
        get_user(){
            this.loading=true
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('用户信息',res)
                if (res.code == 1) {
                    for (const key in this.forms) {
                        this.forms[key]=res.data[key]
                    }
                    this.credit_img=res.data.credit_img.split(',')
                    this.area_ac=[res.data.province,res.data.city,res.data.area]
                } else {
                    // alertErr(res.msg)
                }
            });
        },
         //获取地区列表
         get_area(){
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.area_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //地区选择触发
        handleChange(e){
            console.log('选择',e)
        },
        handle_home(){
            this.$router.push({
                path:'/home'
            })
        },
        //触发上传
        handle_img_add(text){
            let datas={
                form_title:text,
            }
            this.$refs.uploads.uploadFile(datas)
        },
        //上传图片
        upload_url(res_data,datas){
            this[datas.form_title].push(res_data.path)
        },
        //删除图片
        handle_clear(index,text){
            this[text].splice(index,1)
        },
        //提交
        handle_end(){
            if(!this.forms.name){
                alertErr('请输入姓名')
                return
            }
            
            if(!this.forms.mobile){
                alertErr('请输入手机号')
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.forms.mobile)) {
                alertErr('请输入正确的手机号')
                return 
            }

            if(!this.forms.company){
                alertErr('请输入企业名称')
                return
            }
           
            if(this.area_ac.length!=0){
                this.forms.province=this.area_ac[0]
                this.forms.city=this.area_ac[1]
                this.forms.area=this.area_ac[2]
            }
            if(!this.forms.credit){
                alertErr('请输入营业执照号')
                return
            } 
           
            if(this.credit_img.length==0){
                alertErr('请上传营业执照图片')
                return
            }
            this.forms.credit_img=this.credit_img.join(',')

            this.loading=true
            this.$api("supplement", {
                ...this.forms,
			}, "post").then((res) => {
                this.loading = false
                console.log('提交用户信息',res)
                if (res.code == 1) {
                    
                } else {
                    alertErr(res.msg)
                }
            });
            
        },




    },

}
</script>
<style scoped lang="less">
.huiyuan_box{
    width: 100%;
    padding-right:40px ;
    .form_flex_box{
        display: flex;
        align-items: baseline;
        justify-content: space-between;
    }
    .form_flex{
        display: flex;
        // align-items: center;
        padding-bottom: 24px;

        .form_title{
            width: 200px;
            height: 40px;
            line-height: 40px;
            text-align: right;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding-right: 24px;
            flex-shrink: 0;
            span{
                color: #FD4C5C; 
            }
        }
        .input2{
            display: flex;
            align-items: center;
            /deep/.el-select{
                width: 400px;
                height: 40px;
            }
            /deep/.el-input{
                width: 400px;
                height: 40px;
            }
            .input_text1{
                padding-left: 15px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #888888;
 
            }

        }
        .input3{
            width: 100%;
            height: 93px;
            /deep/.el-textarea{
                width: 100%;
                height: 93px;
                .el-textarea__inner{
                    width: 100%;
                    height: 93px;
                    resize:none
                }
            }
        }
        .input4{
            display: flex;
            align-items: center;
        }
        .input_img{
            .img_text{
                line-height: 40px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 12px;
                color: #999999;
            }
            .img_list{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding-top: 8px;
                .img_item{
                    position: relative;
                    width: 80px;
                    height: 80px;
                    margin-right: 10px;
                    .imgs{
                        width: 80px;
                        height: 80px;
                    }
                    .img_clear{
                        position: absolute;
                        right: 0;
                        top: 0;
                        cursor: pointer;
                        width: 20px;
                        height: 20px;
                    }

                }
                .img_add{
                    width: 80px;
                    height: 80px;
                    cursor: pointer;
                }
            }
        }

        .btn_flex{
            display: flex;
            align-items: center;
            .btns1{
                width: 134px;
                height: 40px;
                background: #377CFD;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #377CFD;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 14px;
                color: #FFFFFF;

            }
            .btns2{
                width: 134px;
                height: 40px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #377CFD;
                text-align: center;
                line-height: 40px;
                cursor: pointer;

                margin-left: 10px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 14px;
                color: #377CFD;

            }
        }
    }
}

</style>